import React, { useMemo } from 'react'
import { dialogTypes } from '@/dialogs'
import context from '@/context'
import {
  createLookupFilterCell,
  LookupCell,
  ContactCell,
  Column,
  BooleanColumn
} from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { individualPermissionTypes } from '@/enums/individualPermissionTypes'
import { IndividualPermissionProvider } from '../changeRequests/individualPermissionProvider'

const BranchContacts = React.memo(function BranchContacts ({ dataSource }) {
  return <PermissionsContacts dataSource={dataSource} institutionPermission={institutionPermissionTypes.enum.Branches} />
})

const InstitutionContacts = React.memo(function InstitutionContacts ({ dataSource }) {
  return <PermissionsContacts dataSource={dataSource} institutionPermission={institutionPermissionTypes.enum.Contacts} />
})

const IndividualContacts = React.memo(function IndividualContacts ({ dataSource }) {
  return <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualContacts}>
    <Contacts dataSource={dataSource} />
  </IndividualPermissionProvider>
})

const PermissionsContacts = React.memo(function PermissionsContacts ({ dataSource, institutionPermission }) {
  return <PermissionSectionProvider institutionPermission={institutionPermission}>
    <Contacts dataSource={dataSource} />
  </PermissionSectionProvider>
})

const Contacts = React.memo(function Contacts ({ dataSource }) {
  const { localize } = useLocalization()
  const detailDialog = useMemo(() => ({ dialogType: dialogTypes.contactInformation }), [])
  return (
    <PropertyRenderer name='contacts' inputType='grid' dataSource={dataSource}
      addButtonLabel='Persons.AddContactInformation' detailDialog={detailDialog}>
      <Column field='type' title={localize('Persons.ContactInformationType')} cell={LookupCell}
        filterCell={createLookupFilterCell(context.cache.getContactInformationTypes)} />
      <Column field='value' cell={ContactCell} title={localize('Persons.ContactInformationValue')} />
      {BooleanColumn({ field: 'primary', title: localize('Persons.PrimaryContactInformation') })}
    </PropertyRenderer>
  )
})

export { InstitutionContacts, IndividualContacts, BranchContacts, Contacts }



// WEBPACK FOOTER //
// ./src/components/demographics/contacts.js